import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';
import { UserRole } from '@bo-client/shared/models/user-roles.enum';

@Component({
  selector: 'app-feedback-card',
  templateUrl: './feedback-card.component.html',
  styleUrls: ['./feedback-card.component.scss']
})
export class FeedbackCardComponent implements OnInit {
  @Input() originalModel: any;
  @Input() formGroup: FormGroup;

  constructor(public authorizationService: AuthorizationService) {}

  ngOnInit(): void {}

  get shouldShowFeedbackCard(): boolean {
    return this.originalModel.networkOperatorFeedbackComment;
  }

  get canEditInstallerComment(): boolean {
    return this.originalModel.state === 'FeedbackNeeded' || this.originalModel.state == 'DefectReported';
  }

  get isEditor(): boolean {
    return this.authorizationService.hasRole('ROLE_EDITOR_BASE');
  }

  get networkOperatorFeedbackComment(): string {
    return this.originalModel.networkOperatorFeedbackComment;
  }

  get installerFeedbackComment(): string {
    return this.originalModel.installerFeedbackComment;
  }
}
